var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"52","height":"1","viewBox":"0 0 52 1","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('line',{attrs:{"y1":"0.5","x2":"52","y2":"0.5","stroke":"#F8F8F8"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }